import { axiosAPI } from 'utils';

const fallbackError = (err) => {
  console.error(err);
  return err?.response?.data || { success: false, error: err?.message || 'Request failed' };
};

export default {
  resolve(params = {}) {
    const query = new URLSearchParams();

    if (params.code) query.set('code', params.code);
    if (params.name) query.set('name', params.name);
    if (params.displayName) query.set('displayName', params.displayName);

    const suffix = query.toString() ? `?${query.toString()}` : '';

    return axiosAPI
      .get(`api/admin/provider-language-codes/resolve${suffix}`)
      .then((res) => res.data)
      .catch(fallbackError);
  },
};
